import React, { useEffect, useState } from "react";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { InfiLoader } from "../components/loader";
import { Link } from "react-router-dom";
import ButtonContainer from "../components/buttonContainer";
import SearchContainer from "../components/searchContainer";
import { useUser } from "../config/userProvider";
import { IoAddOutline } from "react-icons/io5";
import FormatDateTime from "../components/formatDateTime";
import { apiurl } from "../config/config";
import Input from "../components/inputContainer";
import Card from "../components/card";
import { BlackButton } from "../components/buttonContainer";
import DataNotFound from "../components/dataNotFound";
import BackHeader from "../components/backHeader";
import Pagination from "../components/pagination";
// import { FiSearch } from "react-icons/fi";

function Broadcasts() {
  const { userData } = useUser();
  let vendorObjId = userData?.vendorDetails?.vendorObjId;
  const [storeData, setStoreData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [detail, setDetail] = useState("");

  // =================== PAGINATION =================
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState("");
  // const [deleteCustomerIds, setDeleteCustomerIds] = useState([]);
  // const [isDeleted, WantToDelete] = useState(false);

  // Calculate the current items to display
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // =======================================================

  console.log("detail", detail);

  // useEffect(() => {
  //   setLoading(true);
  //   const data = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //     // page: currentPage,
  //     // limit: JSON.parse(itemsPerPage),
  //   });

  //   const config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/broadcast/get`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       if (response.data.success === true) {
  //         setStoreData(response.data.broadcasts);
  //         setLoading(false);
  //         setPaginationData(response?.data?.pagination);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setLoading(false);
  //     });
  // }, [currentPage, itemsPerPage]);

  useEffect(() => {
    setLoading(true);

    const data = JSON.stringify({
      vendorObjId: vendorObjId,
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/broadcast/get`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.success === true) {
          setStoreData(response.data.broadcasts);
          setLoading(false);
          setPaginationData(response?.data?.pagination);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [currentPage, itemsPerPage, vendorObjId]);

  const filterData = storeData
    ? storeData.filter((product) =>
        product.broadcastsname
          .toLowerCase()
          .includes(searchInput.toLowerCase()),
      )
    : [];

  return (
    <Layout>
      <Container>
        {loading === true ? (
          <InfiLoader maintext="Fetching Broadcasts Data..." />
        ) : (
          <div className="border  border-slate-200 rounded-lg md:rounded-xl h-full w-full px-5 py-3">
            <div className="flex flex-col gap-3 h-full w-full">
              <div className="w-full h-full flex flex-col">
                <div className="flex flex-col md:flex-row bg-white w-full text-center justify-between items-center md:h-[10%] py-4 gap-2 md:gap-5">
                  <BackHeader
                    title={
                      <span className="flex flex-col md:flex-row items-center">
                        Broadcasts
                        <span className="hidden lg:flex">
                          {" "}
                          - {paginationData?.totalItems}
                        </span>
                        <select
                          value={itemsPerPage}
                          className="text-xs rounded text-black border px-2 mx-2"
                          onChange={(e) => setItemsPerPage(e.target.value)}
                        >
                          {/* <option value="10">10</option> */}
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="250">250</option>
                          <option value="500">500</option>
                          <option value="1000">1000</option>
                        </select>
                      </span>
                    }
                    rightSide={
                      <div className="flex items-center gap-2">
                        <div>
                          <Link to="/broadcasts/create">
                            <ButtonContainer icon={<IoAddOutline />}>
                              <span className="hidden md:block">Create</span>
                            </ButtonContainer>
                          </Link>
                        </div>
                        <div className="hidden md:flex">
                          <SearchContainer
                            value={searchInput}
                            placeholder={"Search Offer..."}
                            onChange={(e) => setSearchInput(e.target.value)}
                          />
                        </div>
                      </div>
                    }
                  />
                </div>
                <div className="md:h-[90%] overflow-hidden w-full">
                  <div className="flex flex-col relative h-full">
                    <div className="overflow-x-auto sm:rounded-lg h-full">
                      {filterData && filterData.length > 0 ? (
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                          <thead className="text-xs text-gray-700 uppercase bg-gray-50   sticky top-0">
                            <tr>
                              <th scope="col" className="px-6 py-3">
                                Broadcast Name
                              </th>
                              <th scope="col" className="px-6 py-3 ">
                                Created At
                              </th>
                              {/* <th scope="col" className="px-6 py-3 ">
                              Launch Date
                            </th> */}
                              <th scope="col" className="px-6 py-3 ">
                                Status
                              </th>
                              <th scope="col" className="px-6 py-3 ">
                                Type
                              </th>
                              <th scope="col" className="px-6 py-3 ">
                                Description
                              </th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {filterData &&
                              filterData.length > 0 &&
                              filterData.map((product, index) => (
                                <tr
                                  key={index}
                                  className={`${
                                    index % 2 === 0
                                      ? "odd:bg-white "
                                      : "even:bg-gray-50 "
                                  } border-b`}
                                >
                                  <th
                                    scope="row"
                                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                                  >
                                    {product.broadcastsname}
                                  </th>
                                  <td className="px-6 py-2">
                                    {FormatDateTime(product.createdAt)}
                                  </td>
                                  {/* <td className="px-6 py-2">
                                  {FormatDateTime(product.launchDate)}
                                </td> */}
                                  <td className="px-6 py-2">
                                    {product.status}
                                  </td>
                                  <td className="px-6 py-2">
                                    {product?.mail === "true" ? (
                                      <span className="px-2 bg-red-100 rounded font-medium text-red-600">
                                        mail
                                      </span>
                                    ) : product?.whatsapp === "true" ? (
                                      <span className="px-2 bg-green-100 rounded font-medium text-green-600">
                                        whatsApp
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td className="px-6 py-2">
                                    {product.description}
                                  </td>
                                  <td>
                                    <button
                                      className="text-blue-500  border-b border-transparent hover:border-blue-500"
                                      onClick={() => setDetail(product)}
                                    >
                                      View
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      ) : (
                        <DataNotFound.Page label="Broadcast" />
                      )}
                    </div>
                  </div>
                </div>
                <Pagination
                  currentPage={currentPage}
                  totalItems={paginationData?.totalItems}
                  itemsPerPage={itemsPerPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>

            {detail && (
              <Card.AddPopUp height="auto" removePopUp={() => setDetail("")}>
                <div className="flex justify-between items-center">
                  <p className="font-bold text-3xl">{detail?.broadcastsname}</p>
                  <p
                    className={` px-3 p-1 rounded-md font-semibold capitalize  ${
                      detail?.status === "active"
                        ? "bg-green-50 text-green-700"
                        : "bg-red-50 text-red-700"
                    }`}
                  >
                    {detail?.status}
                  </p>
                </div>

                <div className="my-5">
                  <Input.Normal
                    label="Created At"
                    value={String(FormatDateTime(detail?.createdAt))}
                  />
                  <Input.TextArea
                    label="description"
                    disabled
                    value={detail?.description}
                  />
                </div>
                <div>
                  <BlackButton title="launch" />
                </div>
              </Card.AddPopUp>
            )}
          </div>
        )}
      </Container>
    </Layout>
  );
}

export default Broadcasts;
